<script>
import Base from "@/components/RequestDetails/AgentData.vue";

export default {
  name: "DefaultViewAgentData",
  extends: Base,
};
</script>

